<template lang='pug'>
  .re-route-container
    div(style="textAlign: center")
      img(src="apple-touch-icon.png")
      h1 You don't have access to this page
      h2 You will be routed back to the control panel
      h2 {{time}}
</template>

<script>
  import { config_obj } from '../utils/firebase'
  export default {
    data() {
      return {
        time: 3,
        campaign: "",
        brand: ""
      }
    },
    mounted(){
      let timer
      const timer_interval = () => {
        return setInterval(()=>{
          if(this.time === 0){
            this.time = "Redirecting........"
            clearInterval(timer)
            window.location.href = `${config_obj.cp_base_path}/${this.brand}/campaigns/${this.campaign}/landing-pages`
          }
          else {
            this.time = this.time -= 1
          }
        },1000)
      }
      timer = timer_interval()
    },
    beforeRouteEnter (to, from, next) {
      const route = from.path.split('/')
      next(vue_instance => {
        vue_instance.campaign = route[4]
        vue_instance.brand = route[2]
      })
    },
  }
</script>

<style lang='scss'>
  .re-route-container {
    width: 100vw;
    height: 100vh;
    background-color: #F4F3F5;
  }
</style>
